<template>
  <div class="TicketCreate">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <div class="page-header-content">
                <h1 class="page-header-title">
                  <div class="page-header-icon">
                    <i data-feather="activity"></i>
                  </div>
                  <span>Create a support ticket</span>
                </h1>
                <!--  <div class="page-header-subtitle">Support Ticketing Reports</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n10">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <transition name="custom-classes-transition" enter-active-class="animated bounceInLeft" leave-active-class="animated bounceOutRight">
              <div class="card bg-light mb-3" v-show="animate">
                <div class="card-body">
                  <p>Please provide your name, email, and phone. Select a {{ topCategoryLabel }} and {{ subCategoryLabel }}, add subject and message body.</p>
                  <p>
                    If you want to create a ticket
                    <b>anonymously</b>, please <router-link :to="{ name: 'TicketCreateAnonymously' }">click here</router-link>.
                  </p>
                  .
                  <form @submit="handleSubmit" enctype="multipart/form-data">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="verifyEmail">Email</label>
                          <input type="text" v-model="email" class="form-control" placeholder="e.g. john@gmail.com" :class="{ 'is-invalid': $v.email.$error, 'is-valid': !$v.email.$invalid }" />
                          <div class="invalid-feedback">
                            <span v-if="!$v.email.required">Email is required.</span>
                            <span v-if="!$v.email.email">Email must be valid email address.</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="name">Name</label>
                          <input type="text" v-model="name" class="form-control" placeholder="e.g. John Smith" :class="{ 'is-invalid': $v.name.$error, 'is-valid': !$v.name.$invalid }" />
                          <div class="invalid-feedback">
                            <span v-if="!$v.name.required">Name is required.</span>
                            <span v-if="!$v.name.minLength">Name must be at least {{ $v.name.$params.minLength.min }} letters.</span>
                            <span v-if="!$v.name.maxLength">Name must be at most {{ $v.name.$params.maxLength.max }} letters.</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="phone">Phone number</label>
                          <input type="text" v-model="phone" class="form-control" placeholder="e.g. 08011223344" :class="{ 'is-invalid': $v.phone.$error, 'is-valid': !$v.phone.$invalid }" />
                          <div class="invalid-feedback">
                            <span v-if="!$v.phone.required">Phone is required.</span>
                            <span v-if="!$v.phone.numeric">Phone must be numeric.</span>
                            <span v-if="!$v.phone.minLength">Phone must be at least {{ $v.phone.$params.minLength.min }} digits.</span>
                            <span v-if="!$v.phone.maxLength">Phone must be at most {{ $v.phone.$params.maxLength.max }} digits.</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="category">{{ topCategoryLabel }}</label>
                      <select @change="topSelected($event)" class="form-control" :class="{ 'is-invalid': $v.category.$error, 'is-valid': !$v.category.$invalid }">
                        <option value="Select..." selected>Select...</option>
                        <option v-for="(item, index) in categories" :key="index" :value="index">{{ item.name }}</option>
                      </select>
                      <div class="invalid-feedback">
                        <span v-if="!$v.category.required">{{ topCategoryLabel }} is required.</span>
                      </div>
                    </div>

                    <transition name="custom-classes-transition" enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutUp">
                      <div class="form-group" v-show="showSubCat">
                        <label for="subCategory">{{ subCategoryLabel }}</label>
                        <select class="form-control" v-model="subCategory" :class="{ 'is-invalid': $v.subCategory.$error, 'is-valid': !$v.subCategory.$invalid }">
                          <!-- <option value="Select..." selected>Select...</option> -->
                          <option v-for="(item, index) in subCategories" :key="index" :value="item.uuid">{{ item.name }}</option>
                        </select>
                        <div class="invalid-feedback">
                          <span v-if="!$v.subCategory.required">{{ subCategoryLabel }} is required.</span>
                        </div>
                      </div>
                    </transition>

                    <div class="form-group">
                      <label for="title">Subject</label>
                      <input type="text" v-model="subject" class="form-control" placeholder="e.g. General Enquiry" :class="{ 'is-invalid': $v.subject.$error, 'is-valid': !$v.subject.$invalid }" />
                      <div class="invalid-feedback">
                        <span v-if="!$v.subject.required">Subject is required.</span>
                        <span v-if="!$v.subject.minLength">Message must be at least {{ $v.subject.$params.minLength.min }} letters.</span>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="message">Message</label>
                      <!-- <textarea v-model="message" cols="30" rows="10" class="form-control" :class="{ 'is-invalid': $v.message.$error, 'is-valid': !$v.message.$invalid}"></textarea> -->
                      <vue-editor v-model="message" :editorToolbar="editorToolbar"></vue-editor>
                      <div class="text-danger text-xs" v-show="$v.message.$error">
                        <span v-if="!$v.message.required">Message is required.</span>
                        <span v-if="!$v.message.minLength">Message must be at least {{ $v.message.$params.minLength.min }} letters.</span>
                      </div>
                    </div>

                    <div class="form-group">
                      <i class="fa fa-paperclip"></i> Attachment
                      <input type="file" ref="file" multiple="multiple" />

                      <p class="help-block"><b>File Type:</b> jpg,jpeg,png,gif,pdf,doc,docx,xls,xlsx | <b>Max file size:</b> 5MB</p>
                    </div>

                    <button class="btn btn-danger btn-lg" type="submit" id="submitButton__" disabled__="disabled__"><i class="far fa-paper-plane mr-1"></i> Send</button>
                  </form>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";
import { required, email, numeric, minLength, maxLength, minValue } from "vuelidate/lib/validators";

export default {
  name: "TicketCreate",

  data() {
    return {
      showSubCat: false,
      animate: false,
      categories: [],
      subCategories: [],

      // Form data
      name: "",
      email: "",
      phone: "",
      category: "",
      subCategory: "",
      subject: "",
      message: "",

      editorToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
    };
  },

  mounted() {
    //this.setLables();
    //this.$store.dispatch("setLables");
    this.animate = true;
    axios.get("/categories").then((res) => {
      if (res.data.status == "success") {
        this.categories = res.data.categories;
      }
    });
  },

  methods: {
    handleSubmit(e) {
      e.preventDefault();
      let loading = this.$loading.show();
      this.$v.$touch();
      if (this.$v.$invalid) {
        loading.hide();
        return;
      }

      let formData = new FormData();
      let allowedExtensions = ["jpg", "jpeg", "png", "gif", "pdf", "doc", "docx", "xls", "xlsx"];

      for (var i = 0; i < this.$refs.file.files.length; i++) {
        let file = this.$refs.file.files[i];
        formData.append("files[" + i + "]", file);
        // Form Validate ...
        let fileName = file.name;
        let fileExtension = fileName.replace(/^.*\./, "");
        if (allowedExtensions.includes(fileExtension) == false) {
          let msg = "." + fileExtension + " file not allowed. Please replace " + file.name;
          this.$swal("Oops!", msg, "error");
          loading.hide();
          return;
        }
        if (file.size > 5000000) {
          let msg = file.name + " is larger than the allowed file size of 5MB.";
          this.$swal("Oops!", msg, "error");
          loading.hide();
          return;
        }
      }

      formData.append("topCategoryID", this.category);
      formData.append("subCategoryID", this.subCategory);
      formData.append("subject", this.subject);
      formData.append("message", this.message);
      formData.append("email", this.email);
      formData.append("phone", this.phone);
      formData.append("name", this.name);
      formData.append("originURL", window.location.origin);

      axios
        .post("/ticket/create", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          if (res.data.status == "success") {
            this.$v.$reset();
            //empty form
            this.name = "";
            this.email = "";
            this.phone = "";
            this.category = "";
            this.subCategory = "";
            this.subject = "";
            this.message = "";
            // fee back
            this.$swal(res.data.title, res.data.message, "success");
            this.$router.push({ name: "TicketDetails", params: { ref: res.data.ticketID } });
          } else {
            this.$swal("Oops!", res.data.message, "error");
          }
          loading.hide();
        })
        .catch((err) => {
          loading.hide();
        });
    },

    topSelected(e) {
      if (e.target.value == "Select...") {
        this.showSubCat = false;
        return;
      }
      this.subCategories = this.categories[e.target.value].subCategories;
      this.showSubCat = true;
      this.category = this.categories[e.target.value].uuid;
    },
  },

  computed: {
    topCategoryLabel() {
      return this.$store.state.client.topCategoryLabel;
    },
    subCategoryLabel() {
      return this.$store.state.client.subCategoryLabel;
    },
  },

  validations: {
    name: { required, minLength: minLength(2), maxLength: maxLength(30) },
    email: { required, email },
    phone: { required, numeric, minLength: minLength(11), maxLength: maxLength(11) },
    category: { required },
    subCategory: { required },
    subject: { required, minLength: minLength(2) },
    message: { required, minLength: minLength(10) },
  },

  components: {
    VueEditor,
  },
};
</script>

<style scoped>
.myselect {
  border-radius: 0 !important;
}
</style>